<template>
	<div class="mt-3">
		<b-form>
			<b-row>
				<b-col xl="4" lg="4" sm="6">
					<p class="mt-3">
						<span class="h3">IMSI</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="6">
					<b-form-group label-for="input-1">
						<b-form-input type="text" :state="validate" v-model="imsi"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row v-if="response.message !== null">
				<b-col xl="4" lg="4" sm="6">
					<p class="mt-3">
						<span class="h3">PSI</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="6">
					<b-form-group label-for="input-1">
						<b-form-textarea rows="8" :class="response.status === 'error'? 'border-red':'border-green'" type="text" :state="true" v-model="response.message"></b-form-textarea>
					</b-form-group>
				</b-col>
			</b-row>
			<hr />
			<div class="mt-3 d-flex justify-content-between">
				<base-button type="danger" title="Close" v-on:click="modalClose()"> Close </base-button>
				<base-button type="primary" title="Search" :disabled="!validate" v-on:click="sendPsiSubmit" :loading="submitLoading">
					Submit
				</base-button>
			</div>
		</b-form>
	</div>
</template>

<script>
import searchDetailService from "../../common/api-services/search-details-service";
import handleResponse from "../../common/directive/handlResponse";

export default {
	name: "Send-PSI",
	data() {
		return {
			imsi: "",
			submitLoading: false,
			response: {
				status: "",
				message: null,
			},
		};
	},
	computed: {
		validate() {
			return this.imsi.length === 15;
		},
	},
	mounted() {
		this.$root.$on("sendPSI", imsi => {
			this.imsi = imsi;
		});
	},
	methods: {
		sendPsiSubmit() {
			this.submitLoading = true;
			searchDetailService.getProvideSubscriberInfo(this.imsi).then(res => {
				// console.log("sendPSI:", res);
				if (res && String(res).includes("Error")) {
					this.response.status = "error";
					this.response.message = res;
					this.submitLoading = false;
					return;
				}
				this.response.status = "success";
				this.response.message = res;
                this.submitLoading = false;
				// this.modalClose();
				// this.$toast.success(res);
			})
            .catch(err => {
				console.log("sendPSI:", err);
                this.submitLoading = false;
				// this.modalClose();
                // this.$toast.error(err);
            })
		},

		modalClose() {
			this.$bvModal.hide("send-psi");
		},
	},
};
</script>
